import React from 'react'
import './FeaturedLevels.css'

const FeaturedLevels = () => {
    return (
        <section className="exciting-feauters-section">
            {/* === Exciting Features heading === */}
            <div className="exciting-feauters-section-heading" style={{background: `url('/img/f-l.png')`}}>
                <div className="container">
                    <div className="exciting-feauters-heading-content">
                        <h1 className="invisible-title">Featured</h1>
                        <h2 className="heading-title">Featured Levels</h2>
                        <div className="features-separetor"></div>
                        <p className="description">Our packages suit all business types in the party and event industry in Australia</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeaturedLevels
